/* CANFOTO V67BS-R5 — NEW Shadow-only Panel Main-Key Band.
   This file does not write to NORA scoring, rank, UI, cache or General F/P.
   Watt bands are engineering screening candidates, NOT photometric proof. */
(function(){ 'use strict';
 var VERSION='CANFOTO-NORA-PANEL-MAIN-KEY-BAND-V67BS-R5';
 var BANDS=Object.freeze({
  close_tabletop:Object.freeze({minCandidateW:70, idealCandidateW:100, area:'close_tabletop'}),
  single_person:Object.freeze({minCandidateW:115, idealCandidateW:150, area:'single_person'}),
  two_person:Object.freeze({minCandidateW:160, idealCandidateW:200, area:'two_person'}),
  wide_scene:Object.freeze({minCandidateW:200, idealCandidateW:300, area:'wide_scene'})
 });
 function num(v){if(v===null||v===undefined||v==='')return null;var n=Number(v);return Number.isFinite(n)&&n>=0?n:null;}
 function bandFor(selectionKey){var k=String(selectionKey||'');
  if(/two_person_interview|large_product_model|fixed_studio_setup|group|family/.test(k))return 'two_person';
  if(/small_product_tabletop|marketplace_catalog|dental_support|beauty|macro|closeup|close_up|desk|live_stream|vlog/.test(k))return 'close_tabletop';
  if(/interview|model_shoot|single_person|portrait|talking_head/.test(k))return 'single_person';
  return null; /* never guess a role for unclassified subpurposes */
 }
 function assess(selectionKey,technical,opts){
  opts=opts||{};var bandKey=opts.bandKey||bandFor(selectionKey);var band=BANDS[bandKey];
  var effectiveW=num(technical&&technical.effectiveWhitePowerW);
  var result={version:VERSION,selectionKey:String(selectionKey||''),bandKey:bandKey||null,
   effectiveWhitePowerW:effectiveW,nominalW:num(technical&&technical.nominalPowerW),
   currentNoraScoreChanged:false,currentNoraRankChanged:false,fpSCurveChanged:false,shadowOnly:true,
   result:'UNKNOWN',capacityScreen:'UNKNOWN',photometricFitness:'UNKNOWN',
   evidence:'SCREENING_ONLY_NOT_LUX_CERTIFICATION',reason:null};
  if(!band){result.reason='ALT_AMAC_ROLE_BAND_NOT_MAPPED';return result;}
  result.minimumCandidateW=band.minCandidateW;result.idealCandidateW=band.idealCandidateW;
  if(effectiveW===null){result.reason='EFFECTIVE_WHITE_POWER_UNKNOWN';return result;}
  result.capacityScreen=effectiveW<band.minCandidateW?'BELOW_CANDIDATE_MIN':effectiveW<band.idealCandidateW?'MIN_TO_IDEAL':'AT_OR_ABOVE_IDEAL';
  result.reason='LUX_DISTANCE_MODIFIER_AND_SCENE_EVIDENCE_REQUIRED';
  return result;
 }
 window.CANFOTO_NORA_PANEL_MAIN_KEY_SHADOW_V67BS_R5=Object.freeze({version:VERSION,bands:BANDS,bandFor:bandFor,assess:assess,scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})();
